import React from "react";
import {Typography} from "antd";
const {Title, Text} = Typography;
export const TitleComp = ({planNumber, planTitle}) => {
    return (
        <div style={{textAlign: 'center', marginBottom: 24}}>
            <Title level={2}>{planTitle}</Title>
            {planNumber && (
                <Text type="secondary" style={{fontSize: '16px'}}>
                    Номер плана: {planNumber}
                </Text>
            )}
        </div>
    )
}